import { LanguageSelector } from '@/components/language-selector';
import { useHeaderMainMenuNavigation } from '@/hooks';
import { MenuGroupIC } from '@/lib/interface-types';
import ExternalLinkIcon from '@/public/icons/external-link.svg';
import LogoImage from '@/public/logo.svg';
import { ENV_URL_MAP } from '@/utils/url';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import uuid from 'react-uuid';
import NavigationItem from './navigation-item';

const HeaderCtf = () => {
  const { locale } = useRouter();
  const { data, isLoading } = useHeaderMainMenuNavigation(locale);
  const { items } = data?.headerCollection?.items[0]?.menuItemsCollection || [];
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!window) return;
    getUrlLink();
  }, []);

  const closeOtherMenus = () => {
    setOpenSubMenuIndex(null);
  };

  const getUrlLink = () => {
    const { hostname } = window.location;
    setUrl(ENV_URL_MAP[hostname] || 'http://incyber.localhost:3000');
  };

  if (isLoading) return <div>Loading</div>;

  return (
    <div className="HeaderCtf w-full flex flex-row items-center justify-between">
      <Link href="/">
        <Image src={LogoImage} alt="Home page" width={214} height={60} />
      </Link>
      <div>
        <div className="flex items-center justify-end">
          {url && (
            <div className="flex items-start gap-[5px]">
              <Link
                className="text-[1.063rem] text-base font-bold text-brand-green single-underline-animation"
                href={url}
                target="_blank"
              >
                CONSULTEER INCYBER
              </Link>
              <Image src={ExternalLinkIcon} alt="External link icon" />
            </div>
          )}
          <LanguageSelector />
        </div>
        <nav className="HeaderNavigation flex flex-row items-center mt-[10px]">
          {items &&
            items.map((groupItem: MenuGroupIC, index: number) => (
              <NavigationItem
                groupItem={groupItem}
                key={uuid()}
                closeOtherMenus={closeOtherMenus}
                isOpen={openSubMenuIndex === index}
              />
            ))}
        </nav>
      </div>
    </div>
  );
};

export default HeaderCtf;
